/**
 * Formatea una fecha en el formato dd/MM
 * @param {Date} date - Fecha a formatear
 * @returns {string} Fecha formateada
 */
export const format = (date, formatStr) => {
  if (!date) return '';
  
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  
  return formatStr
    .replace('dd', day)
    .replace('MM', month)
    .replace('yyyy', year);
};

/**
 * Formatea un número como moneda en euros
 * @param {number} amount - Cantidad a formatear
 * @returns {string} Cantidad formateada en euros
 */
export const formatEUR = (amount) => {
  if (amount === null || amount === undefined) return '0,00 €';
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}; 